/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
    {
      path: '/dashboard',
      name: 'Dashboard',
      view: 'Dashboard'
    },
    {
      path: '/login',
      name: 'Login',
      view: 'Login'
    },
    {
      path: '/transactions',
      name: 'Transactions',
      view: 'Transactions'
    },
    {
      path: '/users',
      name: 'Users',
      view: 'admin/Users'
    },
    {
      path: '/fishcars',
      name: 'Fishcars',
      view: 'admin/Fishcars'
    },
    {
      path: '/customers',
      name: 'Customers',
      view: 'admin/Customers'
    },
    {
      path: '/kinds',
      name: 'Fish Kinds',
      view: 'admin/Kinds'
    },
    {
      path: '/settings',
      name: 'Settings',
      view: 'admin/Settings'
    }, {
      path: '/admin-cashier',
      name: 'Admin Cashier',
      view: 'admin/AdminCashier'
    },
    {
      path: '/fishcar-reports',
      name: 'Fishcar Reports',
      view: 'reports/FishcarReports'
    },
    {
      path: '/cashier-summary',
      name: 'Cashier Summary',
      view: 'reports/CashierSummary'
    },
    {
      path: '/daily-summary-reports',
      name: 'Daily Summary',
      view: 'reports/DailySummary'
    },
    {
      path: '/analytic-reports',
      name: 'Analytics',
      view: 'reports/Analytics'
    },
    {
      path: '/dispatcher',
      name: 'Dispatcher',
      view: 'apps/Dispatcher'
    },
    {
      path: '/encoder',
      name: 'Encoder',
      view: 'apps/Encoder'
    },
    {
      path: '/weigher',
      name: 'Weighing',
      view: 'apps/Weigher'
    },
    {
      path: '/cashier',
      name: 'Cashier',
      view: 'apps/Cashier'
    },
    {
      path: '/fishcar-ledger',
      name: 'Fishcar ledger',
      view: 'accounting/Fishcar'
    },
    {
      path: '/credit-collection',
      name: 'Credit Collection',
      view: 'accounting/Operations'
    },
    {
      path: '/customer-ledger',
      name: 'Customer`s Ledger',
      view: 'accounting/Customers'
    },
    {
      path: '/payments',
      name: 'Customer`s Payment',
      view: 'apps/MyPayments'
    },
    {
      path: '/monitoring',
      name: 'Payment Monitoring',
      view: 'admin/Monitoring'
    }
  ]
  